export class AuthPrivileges {

  ReadPendingUserRequest: boolean = false;
  CreateUser: boolean = false;
  WriteClass: boolean = false;
  WriteSchoolDay: boolean = false;
  WriteOrganization: boolean = false;
  LockContent: boolean = false;
  StudentAdmin: boolean = false;
  SubstituteTeacher: boolean = false;

  constructor(privileges?: string[]) {
    if(privileges) {
      privileges.forEach(p => {
        this.ReadPendingUserRequest = privileges.includes('READ_PENDING_USER_REQUESTS');
        this.CreateUser = privileges.includes('CREATE_USER');
        this.WriteClass = privileges.includes('WRITE_CLASS');
        this.WriteSchoolDay = privileges.includes('WRITE_SCHOOL_DAY');
        this.WriteOrganization = privileges.includes('WRITE_ORGANIZATION');
        this.LockContent = privileges.includes('LOCK_CONTENT');
        this.StudentAdmin = privileges.includes('STUDENT_ADMIN');
        this.SubstituteTeacher = privileges.includes('SUBSTITUTE_TEACHER');
      });
    }
  }

}
